import moment from 'moment'
import {
  SHOW_HOTEL_SEARCHER,
  UPDATE_HOTEL_QUERY,
  SEARCHING_HOTEL,
  SELECT_HOTEL_RESULT,
  GETTING_HOTEL_RESULTS,
  SET_HOTEL_SEARCH_RESULTS,
  CLEAR_HOTEL_RESULTS,
  SHOW_HOTEL_FILTERS,
  SHOW_HOTEL_SORTER,
  UPDATE_HOTEL_SORT,
  UPDATE_HOTEL_FILTERS,
  TOGGLE_HOTEL_RESULT_DETAILS,
  CANCEL_HOTEL_SEARCH,
} from '../../../../../types/conversations/plugins'

export const RESET_SELECTED_HOTEL_RESULTS = 'RESET_SELECTED_HOTEL_RESULTS'
export const SELECT_HOTEL_ROOM = 'SELECT_HOTEL_ROOM'

const initHotelState = {
  productId: '',
  results: [],
  jobId: '',
  searching: false,
  gettingResults: false,
  jobToken: '',
  searcher: {
    show: false,
    errors: {},
    query: {
      result: '',
      location: {},
      checkin: moment().format('YYYY-MM-DD'),
      checkout: moment().add(1, 'day').format('YYYY-MM-DD'),
      adults: 1,
      children: 0,
      // numRooms: 0,
      providers: [],
    },
  },
  filters: {
    budget: [],
    stars: ['1', '2', '3', '4', '5'],
    score: '0',
    popular: [],
  },
  sort: {
    show: false,
    active: 'price:asc',
    options: ['price:asc', 'score:asc'],
  },
  selectedResults: [],
  selectedRooms: {},
  detailedResults: [],
}

export default function hotel(state = initHotelState, action) {
  switch (action.type) {
    case SHOW_HOTEL_SEARCHER: {
      const show = !state.searcher.show
      return Object.assign({}, state, {
        searcher: Object.assign({}, state.searcher, { show }),
      })
    }

    case SHOW_HOTEL_FILTERS: {
      const show = !state.filters.show
      return Object.assign({}, state, {
        filters: Object.assign({}, state.filters, { show }),
      })
    }

    case SHOW_HOTEL_SORTER: {
      const show = !state.sort.show
      return Object.assign({}, state, {
        sort: Object.assign({}, state.sort, { show }),
      })
    }

    case UPDATE_HOTEL_SORT: {
      const { sort } = action
      return Object.assign({}, state, {
        sort: Object.assign({}, state.sort, { active: sort }),
      })
    }

    case UPDATE_HOTEL_FILTERS: {
      const { filters } = action
      return Object.assign({}, state, {
        filters: Object.assign({}, state.filters, filters),
        priceRanges: state.priceRanges ? state.priceRanges : filters.priceRanges || [],
      })
    }

    case UPDATE_HOTEL_QUERY: {
      const { query } = action
      return Object.assign({}, state, {
        searcher: Object.assign({}, state.searcher, {
          query: Object.assign({}, state.searcher.query, query),
        }),
      })
    }

    case SEARCHING_HOTEL: {
      const { searching, jobToken } = action
      return Object.assign({}, state, { searching, jobToken })
    }

    case SELECT_HOTEL_RESULT: {
      const { resultId: hotel } = action

      const selectedRooms = Object.assign({}, state.selectedRooms)
      const selectedResults = [].concat(state.selectedResults)
      const hotelIndex = state.selectedResults.indexOf(hotel._id)

      if (hotelIndex === -1) {
        selectedResults.push(hotel._id)
        selectedRooms[hotel._id] = hotel.booking.data.rooms.map((r) => r.id)
      } else {
        selectedResults.splice(hotelIndex, 1)
        delete selectedRooms[hotel._id]
      }

      return Object.assign({}, state, { selectedResults, selectedRooms })
    }

    case SELECT_HOTEL_ROOM: {
      const { hotelId, roomId } = action

      // Clone all state to new-reference objects
      const selectedRooms = Object.assign({}, state.selectedRooms)
      const selectedResults = [].concat(state.selectedResults)
      const hotelIndex = state.selectedResults.indexOf(hotelId)

      if (hotelIndex === -1) {
        // push hotel into the selected
        selectedResults.push(hotelId)

        // store the selected room
        selectedRooms[hotelId] = [roomId]
      } else {
        const roomIndex = selectedRooms[hotelId].indexOf(roomId)

        if (roomIndex >= 0) {
          // remove hotel room
          selectedRooms[hotelId].splice(roomIndex, 1)

          // remove hotel from selected if there are no rooms to send
          if (selectedRooms[hotelId].length < 1) selectedResults.splice(hotelIndex, 1)
        } else {
          // push the new selected room
          selectedRooms[hotelId].push(roomId)
        }
      }

      return Object.assign({}, state, { selectedResults, selectedRooms })
    }

    case RESET_SELECTED_HOTEL_RESULTS: {
      return Object.assign({}, state, { selectedResults: [], selectedRooms: {} })
    }

    case TOGGLE_HOTEL_RESULT_DETAILS: {
      const { resultId } = action

      const detailedResults = [].concat(state.detailedResults)
      const flightIndex = detailedResults.indexOf(resultId)

      if (flightIndex === -1) detailedResults.push(resultId)
      else detailedResults.splice(flightIndex, 1)

      return Object.assign({}, state, { detailedResults })
    }

    case GETTING_HOTEL_RESULTS: {
      const { jobId, gettingResults } = action
      return Object.assign({}, state, { jobId, gettingResults })
    }

    case SET_HOTEL_SEARCH_RESULTS: {
      const { results, totalResults, more } = action

      if (!state.jobToken) return state

      if (!more) {
        const show = !state.searcher.show
        return Object.assign({}, state, {
          results,
          totalResults,
          searcher: Object.assign({}, state.searcher, { show }),
        })
      }

      return Object.assign({}, state, { results: state.results.concat(results), totalResults })
    }

    case CLEAR_HOTEL_RESULTS: {
      const { results, totalResults, jobId, filters, productId, gettingResults } = initHotelState
      return Object.assign({}, state, {
        results,
        totalResults,
        jobId,
        filters,
        productId,
        gettingResults,
      })
    }

    case CANCEL_HOTEL_SEARCH: {
      const { results, totalResults, jobId, filters, productId, gettingResults, jobToken } = initHotelState
      return Object.assign({}, state, {
        results,
        totalResults,
        jobId,
        jobToken,
        filters,
        productId,
        gettingResults,
        searching: false,
      })
    }

    default: {
      return state
    }
  }
}
